import React from "react";

const STATUS_STYLES = {
  draft: { bg: "#F1F5F9", text: "#475569", border: "#CBD5E1", label: "Draft" },
  awaiting_custody: { bg: "#F8FAFC", text: "#334155", border: "#E2E8F0", label: "Awaiting custody" },
  awaiting_policy: { bg: "#F8FAFC", text: "#334155", border: "#E2E8F0", label: "Awaiting policy" },
  awaiting_assurance: { bg: "#F1F5F9", text: "#1E293B", border: "#CBD5E1", label: "Awaiting assurance" },
  approved: { bg: "#F0FDF4", text: "#166534", border: "#BBF7D0", label: "Approved" },
  refused: { bg: "#FEF2F2", text: "#991B1B", border: "#FECACA", label: "Refused" },
  escalated: { bg: "#FFFBEB", text: "#92400E", border: "#FDE68A", label: "Escalated" },
};

export default function StatusBadge({ status }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center px-2 py-0.5 text-[10.5px] font-medium uppercase tracking-[0.14em] border"
      style={{ background: s.bg, color: s.text, borderColor: s.border, borderRadius: 2 }}
    >
      {s.label}
    </span>
  );
}
